<template>
  <h3 class="body-1-bold my-24">
    {{ i18n(translations.title) }}
  </h3>

  <ul class="mb-24 list-none space-y-12">
    <li v-for="service in services" :key="service.code">
      <RevRadio
        :id="service.code"
        v-model="selectedService"
        :value="service.code"
        variant="full"
      >
        <template #label>
          {{ service.label }}
        </template>
      </RevRadio>
    </li>
  </ul>

  <RevButton
    class="mt-auto"
    :disabled="isDisabled"
    full-width="always"
    type="submit"
    variant="primary"
    @click="goToNextStep"
  >
    {{ i18n(translations.cta) }}
  </RevButton>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevRadio } from '@ds/components/Radio'

import translations from './ServicesSelection.translations'

const { defaultValue, services } = defineProps<{
  services: merchantsAPI.AddressRuleService[] | undefined
  defaultValue: string
}>()
const emit = defineEmits(['next-step'])

const i18n = useI18n()
const selectedService = ref(defaultValue || false)

const isDisabled = computed(() => !selectedService.value)

function goToNextStep() {
  emit('next-step', {
    service: selectedService.value,
  })
}
</script>
